import React, { useEffect, useState } from 'react';
import { store } from '../../../app/store';
import { postAPI, postAPIForm, getURL } from '../../../app/api';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { hasPermission, isAdmin } from '../../../store/hooks/Permission';
import FormSubmissionHandler from '../../../UIComponents/FormSubmissionHandler';
import SelectBoxHandler from '../../../UIComponents/SelectBoxHandler';
import CheckBoxHandler from '../../../UIComponents/CheckBoxHandler';
import CustomImage from '../../../UIComponents/CustomImage';
import CustomLink from '../../../UIComponents/CustomLink';
import FileUploadHandler from '../../../UIComponents/FileUploadHandler';
import NormalTextareaHandler from '../../../UIComponents/NormalTextareaHandler';
import RadioButtonHandler from '../../../UIComponents/RadioButtonHandler';
import TextareaHandler from '../../../UIComponents/TextareaHandler';
import InputHandler from '../../../UIComponents/InputHandler';
import Loader from '../../../UIComponents/Loader';

export default function Form({ is_edit, edit_id, Page = "" }) {
    const store_data = JSON.parse(store());
    const [IsBTNClicked, setIsBTNClicked] = useState(false);
    const [canCreate, setCanCreate] = useState(false);
    const [canEdit, setCanEdit] = useState(false);

    const InitialData = {
        host: "",
        port: "",
        username: "",
        password: ""
    }

    const [FormData, setFormData] = useState(InitialData);
    const [Editing, setEditing] = useState(is_edit);
    const [Error, setError] = useState([]);
    const [Loading, setLoading] = useState(true);

    const fetchSingleData = async (edit_id) => {
        const filter = { org_id: store_data?.org_id, id: edit_id }
        const response = await postAPI("/smtp/fetchSingle", {...filter, user: store_data});
        const SMTPData = response?.data?.length > 0 ? response?.data[0] : {};
        if (response?.status == 1) {
            setFormData({
                id: SMTPData["id"],
                host: SMTPData["host"],
                port: SMTPData["port"],
                username: SMTPData["username"],
                password: SMTPData["password"],
            });
            setLoading(false)
        } else {
            setFormData({});
        }
    }

    useEffect(() => {
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanCreate(true);
                setCanEdit(true);
            } else {
                const createAllowed = await hasPermission("SETTINGS", "SMTPSMS", "CREATE");
                const editAllowed = await hasPermission("SETTINGS", "SMTPSMS", "EDIT");
                setCanCreate(createAllowed);
                setCanEdit(editAllowed);
            }
        };
        checkPermissions();

        setLoading(false)
        if(is_edit)
            fetchSingleData(edit_id)
    }, [is_edit, edit_id])

    const validate = () => {
        let errors = [];
        if (!FormData.host) errors.push('Host is required.');
        if (!FormData.port) errors.push('Port is required.');
        else if (isNaN(FormData.port)) errors.push('Port must be a number.');
        if (!FormData.username) errors.push('Username is required.');
        if (!FormData.password) errors.push('Password is required.');
        setError(errors);
        return errors.length === 0;
    };

    const handleSubmit = async () => {
        setIsBTNClicked(true);
        if (IsBTNClicked) return;
        
        if (!isAdmin() && ((is_edit && !canEdit) || (!is_edit && !canCreate))) {
            toast.error('You do not have permission to perform this action.');
            setIsBTNClicked(false);
            return;
        }
        
        if (!validate()) {
            toast.error('Please fix validation errors.');
            return;
        }
        const payload = { org_id: store_data?.org_id, ...FormData }
        const response = await postAPI(is_edit ? "/smtp/update" : "/smtp/create", {...payload, user: store_data});
        if (response?.status == 1) {
            setIsBTNClicked(false);
            toast.success('SMTP/ SMS Credentials Updated Successfully.');
            window.location.reload();
        } else {
            setIsBTNClicked(false);
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }
    return (
        <>
            {Loading ? <Loader /> :
                store_data?.role === 'EMPLOYEE' && !hasPermission ? (
                    <div className="alert alert-danger">You do not have permission to access this form.</div>
                ) : (
                    <FormSubmissionHandler handleSubmit={handleSubmit} editing={is_edit} error={Error} BTNLabel="Save" IsBTNClicked={IsBTNClicked}>
                        <div className="col-12 col-md-6 mt-0">
                            <InputHandler form_data={FormData} setFormData={setFormData} Name="host" Type="text" Label="Host" />
                        </div>
                        <div className="col-12 col-md-6 mt-0">
                            <InputHandler form_data={FormData} setFormData={setFormData} Name="port" Type="text" Label="Port" />
                        </div>
                        <div className="col-12 col-md-6 mt-0">
                            <InputHandler form_data={FormData} setFormData={setFormData} Name="username" Type="text" Label="Username" />
                        </div>
                        <div className="col-12 col-md-6 mt-0">
                            <InputHandler form_data={FormData} setFormData={setFormData} Name="password" Type="text" Label="Password" />
                        </div>
                        {Error.length > 0 && (
                            <div className="alert alert-danger">
                                <ul>{Error.map((e, i) => <li key={i}>{e}</li>)}</ul>
                            </div>
                        )}
                    </FormSubmissionHandler>
                )
            }
            <ToastContainer  position="bottom-right" autoClose={5000} hideProgressBar={true} closeOnClick={true} pauseOnHover={false} draggable={false} progress="1" theme="dark" transition={Slide} />
        </>
    )
}
